import { Component, OnInit } from '@angular/core';
import { lastValueFrom } from '@services';
import { RmsModule } from '@rms';
import { OrdersDataService } from '../../../../../services/orders-data.service';
import { RmsPulldownRef } from '../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';

@Component({
  selector: 'app-my-orders-status',
  imports: [RmsModule],
  templateUrl: './my-orders-status.component.html',
  styleUrl: './my-orders-status.component.scss'
})
export class MyOrdersStatusComponent implements OnInit {
  Orders: any[] = [];
  Loading = true;
  ShowUnsentOnly = false;

  constructor(
    private ordersData: OrdersDataService,
    private pulldownRef: RmsPulldownRef
  ) { }

  async ngOnInit() {
    await this.load();
  }

  async load() {
    this.Loading = true;
    try {
      this.Orders = await lastValueFrom(this.ordersData.getMyOrdersStatus());
    } finally {
      this.Loading = false;
    }
  }

  get filteredOrders() {
    return this.ShowUnsentOnly
      ? this.Orders.filter(o => o.NotYetSentToOutbound)
      : this.Orders;
  }

  returnToList() {
    this.pulldownRef.close();
  }
}
